export const LEARNING = {
  apiPrefix: "/api/catalog/",
  launchPrefix: "/api/catalog/launch/course/",
  enabled: process.env.NEXT_PUBLIC_CATALOG_ENABLED === "true",
  publicBrowse: process.env.NEXT_PUBLIC_CATALOG_PUBLIC_BROWSE === "true",
  demo: process.env.NEXT_PUBLIC_CATALOG_DEMO_MODE === "true",
  limit: 12,
  minutesPerHour: 60,
  artworkWidth: 750,
  artworkHeight: 422,
  geoStaleTimeMs: 30 * 60 * 1000,
  skeletonCardCount: 2,
  staleTimeMs: 30_000,
  queryKey: "job-courses",
  recommended: "recommended",
  unauthorized: 401,
  forbidden: 403,
  invalidInput: 422,
  rateLimited: 429,
} as const;
export const LEARNING_PATH = {
  detail: "detail",
  enquiries: "enquiries",
  enquirySession: "enquiry/session",
  phoneRequest: "phone/request",
  phoneVerify: "phone/verify",
  access: "access",
  recommendations: "recommendations",
  launches: "launches",
  start: "auth/start",
  verify: "auth/verify",
  session: "auth/session",
} as const;
export const LEARNING_ERROR = {
  unavailable: "LEARNING_UNAVAILABLE",
  invalidLaunch: "INVALID_COURSE_LAUNCH",
} as const;

export const COURSE_LEVELS = ["beginner", "intermediate", "advanced"] as const;
export const COURSE_CARD_CONTAINER =
  "w-[calc(100%-1.25rem)] max-w-[340px] shrink-0 snap-start";

export const COURSE_DETAIL_SECTIONS = [
  "learning_outcomes",
  "requirements",
  "target_audience",
  "certification_covered",
] as const;

export const COURSE_EXPERIENCE_MESSAGE_KEYS = {
  internship: "jobAlertInternship",
  fresher: "jobAlertFresher",
  "1-3_years": "jobAlert1To3Years",
  "3-5_years": "jobAlert3To5Years",
  "5-7_years": "jobAlert5To7Years",
  "7-10_years": "jobAlert7To10Years",
  "10+_years": "jobAlert10PlusYears",
} as const;

export const COURSE_INTERNSHIP_EXPERIENCE = "internship";
